import React, { useEffect, useState } from "react";
import { StarFill, StarHalf, Star, ChevronUp, Trash } from "react-bootstrap-icons"; // Assuming you're using Bootstrap icons
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import MakeAReviewModal from "./Modals/MakeAReviewModal";
import DeleteRatingModal from "./Modals/DeleteRatingModal";

export default function Reviews({ rating, id, closeReviews, refreshData }) {

  


  const [ratingExists, setRatingExists] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [complete, setComplete] = useState(false);
  const { user } = useAuthContext();
  const [makeAReviewModal,setMakeAReviewModal] = useState(false)
  const [deleteRatingModal,setDeleteRatingModal] = useState(false)
  const [selectingRating,setSelectedRating] = useState(null)

  const cancelModal = () => {
    setMakeAReviewModal(false)
    setDeleteRatingModal(false)
  }

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const rewviewExists = await axios.get(
        `${ApiConnectionString}/api/RatingExists/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setRatingExists(rewviewExists.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);

  const renderStars = (stars) => {
    const fullStars = Math.floor(stars);
    const hasHalfStar = stars % 1 >= 0.5;

    return (
      <div className="d-flex align-items-center">
        {[...Array(5)].map((_, index) => {
          if (index < fullStars) {
            return <StarFill key={index} />;
          } else if (index === fullStars && hasHalfStar) {
            return <StarHalf key={index} />;
          } else {
            return <Star key={index} />;
          }
        })}
      </div>
    );
  };

  return (
    <div>
      <div className="d-flex justify-content-between  customNav rounded">
        <p className="m-2 fw-bold">Reviews</p>
        <ChevronUp size={20} className="m-2 pointer" onClick={closeReviews} />
      </div>
 
      {ratingExists == false && <button  className="oc-red-button p-1 fw-bold m-2" onClick={() => setMakeAReviewModal(true)}>Make a review</button>}
      <div className="scrollable-posts">
        {rating.length > 0 ? (
          rating.map((rev) => (
            <div key={rev.id} className="review-item mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <p className="fw-bold">{rev.viewAppUser.username}</p>
                {renderStars(rev.stars)}
              </div>
              <p>{rev.content}</p>
              {rev.appUserId == user.id && <Trash onClick={() => {setSelectedRating(rev);setDeleteRatingModal(true)}} size={25}/>}
            </div>
          ))
        ) : (
          <p>No reviews available.</p>
        )}
      </div>
      {makeAReviewModal && <MakeAReviewModal cancelModal={cancelModal} id={id} refreshData={refreshData}/>}
      {deleteRatingModal && <DeleteRatingModal cancelModal={cancelModal} id={selectingRating.id} refreshData={refreshData} />}
    </div>
  );
}
